import { render, staticRenderFns } from "./FormRevisionContent.vue?vue&type=template&id=4d56deb1&"
import script from "./FormRevisionContent.vue?vue&type=script&lang=js&"
export * from "./FormRevisionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports